import React from "react";
import DebitBalanceInfoReport from "../modules/DebitBalanceInfoReport";

export default function DebitBalanceInfoReportPage() {
    return <DebitBalanceInfoReport/>
}